import * as UAParser from "ua-parser-js";
const parser = new UAParser();
const ua = parser.getResult();

export const toTime = time => {
    const timeArr = time.split(':');
    return parseInt(timeArr[0] * 60) + parseInt(timeArr[1])
  }
  
export const toHHMMSS = secondsNum => {
    var sec_num = parseInt(secondsNum, 10); // don't forget the second param
    var hours   = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours   < 10) {hours   = "0"+hours;}
    if (minutes < 10) {minutes = "0"+minutes;}
    if (seconds < 10) {seconds = "0"+seconds;}
    // return hours+':'+minutes+':'+seconds;
    return minutes+':'+seconds;
}

export const validUrl = songUrl => {
    return !!songUrl && songUrl !== '' && (songUrl.indexOf('https://') > -1 ||  songUrl.indexOf('http://') > -1);
}

export const checkBrowser = (os, browser, version) => {
    // console.log((ua.os.name === os || !os));
    if (ua.browser.name === 'IE') {
        return true;
    }
    return (ua.os.name === os || !os) && ua.browser.name === browser && parseInt(ua.browser.version.split('.')[0], 10) <= version;
}